import { Component, Inject } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import {RouterService} from "@biletix/core/services/router.service";

@Component({
  standalone: false,
  selector: 'btx-site-logo',
  templateUrl: './site-logo.component.html',
  styleUrls: ['./site-logo.component.scss']
})
export class SiteLogoComponent {
  logoPath: string;

  constructor(
    public routerService: RouterService,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {
    this.logoPath = `${this.baseHref}assets/images/logo.svg`;
  }
}
